define('views/modules/template/edit/calendar/personal-data/personal-data-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // parent view
    'views/modules/calendar/personal-data/item/personal-data-content',
    // views
    'views/modules/template/edit/calendar/personal-data/form/personal-data-details-form',
    'views/parts/menu/menu-save-action',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // parent view
    VPersonalDataDetails,
    // views
    VTemplatePersonalDataDetailsForm,
    VMenuSaveAction
) {

    var VTemplatePersonalDataDetails = VPersonalDataDetails.extend({
        submitFromSave: true,

        initialize: function(opt) {
            VTemplatePersonalDataDetails.__super__.initialize.call(this, opt);

            var view = _.extend(this.view, {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveClick,
                    saveText: "Save",
                    radio: false,
                    tooltip: { container: this.regions.root, }
                }),
                details: new VTemplatePersonalDataDetailsForm({ model: this.model })
            });
        },

        onSaveClick: function() {
            this._onSuccess();
        },

    });

    return VTemplatePersonalDataDetails;

});

